
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f2tcq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");











var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");





var $caCU7 = parcelRequire("caCU7");

const $e2439a5908f943f7$var$i18n = (0, $kSwu1.defineMessages)({
    activeAgentsTitle: {
        id: "team-presence.agent-group-menu.title",
        defaultMessage: "{count, plural, =0 {Active agents ({count})} one {Active agents ({count})} other {Active agents ({count})}}"
    }
});
const $e2439a5908f943f7$var$styles = {
    root: "_0bjKvDKxmn _0KLXruoI2d _2OUyjtGk8v _1mT5xdRAKS _39xV02wBC3"
};
const $e2439a5908f943f7$export$62f6b3db6f977c3c = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { agents: agents } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== agents.length || $[1] !== formatMessage) {
        t1 = formatMessage($e2439a5908f943f7$var$i18n.activeAgentsTitle, {
            count: agents.length
        });
        $[0] = agents.length;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== agents) {
        t2 = agents.map($e2439a5908f943f7$var$_temp);
        $[3] = agents;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e2439a5908f943f7$var$styles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            maxHeight: 480,
            minWidth: 360,
            maxWidth: 360
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            isScrollable: true,
            title: t1
        }, t2)));
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
function $e2439a5908f943f7$var$_temp(agent) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caCU7.AgentPresenceMenuItem), {
        key: agent.id,
        agent: agent
    });
}









var $bcDqz = parcelRequire("bcDqz");


var $w6R6I = parcelRequire("w6R6I");

















var $3izAL = parcelRequire("3izAL");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");




const $54c653dc38243ab4$var$i18n = (0, $kSwu1.defineMessages)({
    groupOverflowLabel: {
        id: "team-presence.group.overflow.label",
        defaultMessage: "Overflow menu"
    }
});
// Base styles for more indicator button - margin will be conditionally applied based on feature gate
const $54c653dc38243ab4$var$moreIndicatorButtonBaseStyle = (0, $buxP3.xcss)({
    minWidth: '28px',
    padding: 'space.0',
    marginInline: 'space.0',
    marginBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineOffset: 'space.050'
    }
});
// Legacy margin styles (used when platform spacing fix is disabled)
const $54c653dc38243ab4$var$moreIndicatorButtonLegacyMarginStyle = (0, $buxP3.xcss)({
    marginInline: 'space.025'
});
const $54c653dc38243ab4$var$moreIndicatorStyle = (0, $buxP3.xcss)({
    padding: 'space.075',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    font: 'font.heading.xxsmall',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'radius.full',
    ':hover': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $54c653dc38243ab4$var$moreIndicatorActiveStyle = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
function $54c653dc38243ab4$export$20d7daf1abbf02fe(isOpen, count) {
    return (_, props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($54c653dc38243ab4$export$21d9599487cab049, {
            count: count,
            isOpen: isOpen,
            ...props
        });
    };
}
const $54c653dc38243ab4$export$21d9599487cab049 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { count: count, isOpen: isOpen, onClick: onClick, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($54c653dc38243ab4$var$i18n.groupOverflowLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            $54c653dc38243ab4$var$moreIndicatorButtonBaseStyle,
            !(0, $9wGTI.fg)("platform-avatar-group-spacing-fix") && $54c653dc38243ab4$var$moreIndicatorButtonLegacyMarginStyle
        ];
        $[2] = t2;
    } else t2 = $[2];
    const t3 = isOpen && $54c653dc38243ab4$var$moreIndicatorActiveStyle;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $54c653dc38243ab4$var$moreIndicatorStyle,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== count || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t4
        }, count);
        $[5] = count;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== onClick || $[9] !== t1 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            "data-vc": "presence-overflow",
            "aria-label": t1,
            onClick: onClick,
            testId: testId,
            xcss: t2
        }, t5);
        $[8] = onClick;
        $[9] = t1;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};



var $iwQHw = parcelRequire("iwQHw");

const $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE = 4;
const $b28d1d3ecd80ad2b$var$styles = {
    root: "_2YLqiKLl21",
    presenceAgentWrapper: "_3iDTPbccYA _3YEZNOdnbC _0hPCNLDIqT _4kiQYAcM5X _0Of8r2FQfX _1wydGWFQfX"
};
const $b28d1d3ecd80ad2b$export$b69254d879536cde = (agents, count)=>{
    return (_, props, index)=>{
        const agent = agents.find((a)=>a.id === props.agentId);
        if (!agent) return null;
        if ((0, $9wGTI.fg)('platform_move_presence_agents')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b28d1d3ecd80ad2b$var$styles.presenceAgentWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent,
            presenceColorKey: agent.presenceId,
            isOverlapped: index > 0,
            size: "small",
            stackIndex: count - index,
            showPresenceBadge: true,
            showBorder: true
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)((0, $9wGTI.fg)('platform-avatar-group-spacing-fix') && $b28d1d3ecd80ad2b$var$styles.root)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent,
            presenceColorKey: agent.presenceId,
            stackIndex: count - index,
            showBorder: true
        }));
    };
};
const $b28d1d3ecd80ad2b$export$192d6a5eae5d7b58 = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { agents: agents, isOpen: isOpen, onMoreClick: onMoreClick } = t0;
    let t1;
    if ($[0] !== agents) {
        t1 = agents.map($b28d1d3ecd80ad2b$var$_temp);
        $[0] = agents;
        $[1] = t1;
    } else t1 = $[1];
    const data = t1;
    let t2;
    if ($[2] !== agents || $[3] !== data.length) {
        t2 = $b28d1d3ecd80ad2b$export$b69254d879536cde(agents, data.length);
        $[2] = agents;
        $[3] = data.length;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = {
            render: t2
        };
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const t4 = data.length - $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE + 1;
    let t5;
    if ($[7] !== isOpen || $[8] !== t4) {
        t5 = (0, $54c653dc38243ab4$export$20d7daf1abbf02fe)(isOpen, t4);
        $[7] = isOpen;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = {
            render: t5
        };
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
        t7 = {
            Avatar: t3,
            MoreIndicator: t6
        };
        $[12] = t3;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== data || $[16] !== onMoreClick || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
            testId: "agent-presence-avatar-group",
            appearance: "stack",
            size: "small",
            maxCount: $b28d1d3ecd80ad2b$var$MAX_GROUP_SIZE,
            data: data,
            shouldPopupRenderToParent: false,
            onMoreClick: onMoreClick,
            overrides: t7
        });
        $[15] = data;
        $[16] = onMoreClick;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    return t8;
};
function $b28d1d3ecd80ad2b$var$_temp(agent) {
    return {
        agentId: agent.id,
        name: agent.name
    };
}



var $c6zRP = parcelRequire("c6zRP");

const $4dfa4fcf3782a7bf$var$hasValidLastActive = (lastActive)=>typeof lastActive === 'number' && Number.isFinite(lastActive);
const $4dfa4fcf3782a7bf$var$isMoreRecentPresence = (current, previous)=>$4dfa4fcf3782a7bf$var$hasValidLastActive(current.lastActive) && (!$4dfa4fcf3782a7bf$var$hasValidLastActive(previous.lastActive) || current.lastActive > previous.lastActive);
const $4dfa4fcf3782a7bf$var$i18n = (0, $kSwu1.defineMessages)({
    agentGroupLabel: {
        id: "team-presence.agent-group.label",
        defaultMessage: "Active agents on content"
    },
    externalAgentName: {
        id: "team-presence.external-agent.name",
        defaultMessage: "External agent"
    }
});
const $4dfa4fcf3782a7bf$var$styles = {
    nestedTrigger: "_3iDTPbccYA _0hPCNLDIqT"
};
const $4dfa4fcf3782a7bf$var$getUniqueAgents = (agents)=>{
    const uniqueAgents = new Map();
    agents?.forEach((agent)=>{
        if (agent) uniqueAgents.set(agent.id, agent);
    });
    return Array.from(uniqueAgents.values());
};
const $4dfa4fcf3782a7bf$var$getUniqueAgentIds = (agentIds)=>Array.from(new Set(agentIds)).sort();
const $4dfa4fcf3782a7bf$var$getAgentIdFromParticipantUserId = (userId)=>userId.replace(/^agent:/, '');
const $4dfa4fcf3782a7bf$var$areAgentPresenceMetadataMapsEqual = (previousPresenceById, nextPresenceById)=>{
    if (previousPresenceById.size !== nextPresenceById.size) return false;
    return Array.from(nextPresenceById).every(([agentId, nextPresence])=>{
        const previousPresence = previousPresenceById.get(agentId);
        return previousPresence?.actingUserId === nextPresence.actingUserId && previousPresence?.permit?.isPermittedToEdit === nextPresence.permit?.isPermittedToEdit && // Compared as well as `isPermittedToEdit`, so a view-permit transition re-renders. Without
        // this an agent gaining or losing view permission would be invisible on the view route,
        // where it is the only permit it has.
        previousPresence?.permit?.isPermittedToView === nextPresence.permit?.isPermittedToView && previousPresence?.presenceActivity === nextPresence.presenceActivity && previousPresence?.presenceId === nextPresence.presenceId && previousPresence?.lastActive === nextPresence.lastActive && previousPresence?.presenceStatus === nextPresence.presenceStatus;
    });
};
const $4dfa4fcf3782a7bf$var$updateCachedAgentsById = (previousAgentsById, activeAgentIds, agentEntries)=>{
    const activeAgentIdSet = new Set(activeAgentIds);
    let nextAgentsById;
    for (const [agentId, agent] of agentEntries)if (activeAgentIdSet.has(agentId) && previousAgentsById.get(agentId) !== agent) {
        nextAgentsById ?? (nextAgentsById = new Map(previousAgentsById));
        nextAgentsById.set(agentId, agent);
    }
    previousAgentsById.forEach((_agent, agentId)=>{
        if (!activeAgentIdSet.has(agentId)) {
            nextAgentsById ?? (nextAgentsById = new Map(previousAgentsById));
            nextAgentsById.delete(agentId);
        }
    });
    return nextAgentsById ?? previousAgentsById;
};
const $4dfa4fcf3782a7bf$var$useActiveAgentPresence = (presenceProvider)=>{
    const $ = (0, $bDgLe.c)(8);
    const [t0] = (0, $hYoU4.useNativeCollabState)();
    const { collabEditProvider: collabEditProvider } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [activeAgentIds, setActiveAgentIds] = (0, $cozmU.useState)(t1);
    const [activeAgentPresenceById, setActiveAgentPresenceById] = (0, $cozmU.useState)($4dfa4fcf3782a7bf$var$_temp);
    const lifecycleTimeoutRef = (0, $cozmU.useRef)(undefined);
    const provider = presenceProvider ?? collabEditProvider;
    let t2;
    let t3;
    if ($[1] !== presenceProvider || $[2] !== provider) {
        t2 = ()=>{
            const clearLifecycleTimeout = ()=>{
                if (lifecycleTimeoutRef.current !== undefined) {
                    window.clearTimeout(lifecycleTimeoutRef.current);
                    lifecycleTimeoutRef.current = undefined;
                }
            };
            const updateActiveAgentIds = (agentIds)=>{
                setActiveAgentIds((prev)=>{
                    const next = $4dfa4fcf3782a7bf$var$getUniqueAgentIds(agentIds);
                    return prev.length === next.length && prev.every((id, i)=>id === next[i]) ? prev : next;
                });
            };
            const getRenderableAIProviderParticipants = ()=>{
                const aiProviderParticipants = provider?.getAIProviderParticipants() ?? [];
                if (!presenceProvider) return aiProviderParticipants;
                return aiProviderParticipants.filter($4dfa4fcf3782a7bf$var$_temp2);
            };
            const handleUpdatePresenceOld = ()=>{
                const aiProviderParticipants_0 = getRenderableAIProviderParticipants();
                const agentIds_0 = aiProviderParticipants_0.map($4dfa4fcf3782a7bf$var$_temp3);
                updateActiveAgentIds(agentIds_0);
            };
            const handleUpdatePresenceNew = ()=>{
                clearLifecycleTimeout();
                const now = Date.now();
                const aiProviderParticipants_1 = getRenderableAIProviderParticipants().filter((agent_1)=>(0, $c6zRP.getAgentPresenceStatus)(agent_1, now) !== "expired");
                const agentPresenceById = new Map();
                let nextLifecycleBoundary;
                aiProviderParticipants_1.forEach((agent_2)=>{
                    const agentId = $4dfa4fcf3782a7bf$var$getAgentIdFromParticipantUserId(agent_2.userId);
                    const lifecycleBoundary = (0, $c6zRP.getNextAgentPresenceBoundary)(agent_2.lastActive, now);
                    if (lifecycleBoundary !== undefined && (nextLifecycleBoundary === undefined || lifecycleBoundary < nextLifecycleBoundary)) nextLifecycleBoundary = lifecycleBoundary;
                    const agentPresence = {
                        actingUserId: agent_2.actingUserId,
                        permit: {
                            isPermittedToEdit: agent_2.permit?.isPermittedToEdit,
                            isPermittedToView: agent_2.permit?.isPermittedToView
                        },
                        presenceActivity: agent_2.presenceActivity,
                        presenceId: agent_2.presenceId ?? agent_2.userId,
                        lastActive: agent_2.lastActive,
                        presenceStatus: (0, $c6zRP.getAgentPresenceStatus)(agent_2, now)
                    };
                    const previousPresence = agentPresenceById.get(agentId);
                    if (!previousPresence || $4dfa4fcf3782a7bf$var$isMoreRecentPresence(agentPresence, previousPresence)) agentPresenceById.set(agentId, agentPresence);
                });
                updateActiveAgentIds(Array.from(agentPresenceById.keys()));
                setActiveAgentPresenceById((prev_0)=>$4dfa4fcf3782a7bf$var$areAgentPresenceMetadataMapsEqual(prev_0, agentPresenceById) ? prev_0 : agentPresenceById);
                if (nextLifecycleBoundary !== undefined) lifecycleTimeoutRef.current = window.setTimeout(handleUpdatePresence, Math.max(0, nextLifecycleBoundary - now));
            };
            const handleUpdatePresence = ()=>{
                if ((0, $9wGTI.fg)("platform_move_presence_agents")) {
                    handleUpdatePresenceNew();
                    return;
                }
                handleUpdatePresenceOld();
            };
            handleUpdatePresence();
            provider?.on("presence", handleUpdatePresence);
            if ((0, $9wGTI.fg)("platform_move_presence_agents")) provider?.on("presence:changed", handleUpdatePresence);
            return ()=>{
                clearLifecycleTimeout();
                provider?.off("presence", handleUpdatePresence);
                if ((0, $9wGTI.fg)("platform_move_presence_agents")) provider?.off("presence:changed", handleUpdatePresence);
            };
        };
        t3 = [
            presenceProvider,
            provider
        ];
        $[1] = presenceProvider;
        $[2] = provider;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[5] !== activeAgentIds || $[6] !== activeAgentPresenceById) {
        t4 = {
            activeAgentIds: activeAgentIds,
            activeAgentPresenceById: activeAgentPresenceById
        };
        $[5] = activeAgentIds;
        $[6] = activeAgentPresenceById;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $4dfa4fcf3782a7bf$var$buildAssistanceServiceParams = (cloudId)=>({
        siteId: cloudId,
        product: 'confluence',
        experienceId: 'ai-mate',
        touchpointSource: 'aiAgentPresence'
    });
const $4dfa4fcf3782a7bf$var$AgentPresenceView = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { activeAgents: activeAgents, isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isAgentGroupOverflowOpen, setIsAgentGroupOverflowOpen] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== activeAgents || $[1] !== isNestedInPresenceAvatarGroup || $[2] !== onActiveAgentsChange) {
        t1 = ()=>{
            if (!(0, $9wGTI.fg)("platform_move_presence_agents") || !isNestedInPresenceAvatarGroup || !onActiveAgentsChange) return;
            onActiveAgentsChange(activeAgents);
            return ()=>{
                onActiveAgentsChange([]);
            };
        };
        t2 = [
            activeAgents,
            isNestedInPresenceAvatarGroup,
            onActiveAgentsChange
        ];
        $[0] = activeAgents;
        $[1] = isNestedInPresenceAvatarGroup;
        $[2] = onActiveAgentsChange;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== createAnalyticsEvent) {
        t3 = (agentCount)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "aiAgentPresence",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "aiAgentPresenceGroupOverflow",
                    product: "confluence",
                    attributes: {
                        agents: agentCount
                    }
                }
            }).fire();
            setIsAgentGroupOverflowOpen($4dfa4fcf3782a7bf$var$_temp4);
        };
        $[5] = createAnalyticsEvent;
        $[6] = t3;
    } else t3 = $[6];
    const handleAgentGroupOverflowMenuClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsAgentGroupOverflowOpen(false);
        };
        $[7] = t4;
    } else t4 = $[7];
    const handleAgentGroupOverflowMenuClose = t4;
    let t5;
    if ($[8] !== activeAgents) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2439a5908f943f7$export$62f6b3db6f977c3c), {
                agents: activeAgents
            });
        $[8] = activeAgents;
        $[9] = t5;
    } else t5 = $[9];
    const renderAgentGroupOverflowMenu = t5;
    let t6;
    let t7;
    if ($[10] !== activeAgents.length) {
        t6 = ()=>{
            if (!activeAgents.length) setIsAgentGroupOverflowOpen(false);
        };
        t7 = [
            activeAgents.length
        ];
        $[10] = activeAgents.length;
        $[11] = t6;
        $[12] = t7;
    } else {
        t6 = $[11];
        t7 = $[12];
    }
    (0, $cozmU.useEffect)(t6, t7);
    if (!activeAgents?.length || isNestedInPresenceAvatarGroup) return null;
    let t8;
    if ($[13] !== activeAgents || $[14] !== formatMessage || $[15] !== handleAgentGroupOverflowMenuClick || $[16] !== isAgentGroupOverflowOpen || $[17] !== isNestedInPresenceAvatarGroup) {
        t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ...triggerProps,
                paddingInline: "space.025",
                xcss: isNestedInPresenceAvatarGroup && $4dfa4fcf3782a7bf$var$styles.nestedTrigger,
                "aria-label": isNestedInPresenceAvatarGroup ? undefined : formatMessage($4dfa4fcf3782a7bf$var$i18n.agentGroupLabel),
                role: isNestedInPresenceAvatarGroup ? undefined : "region"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b28d1d3ecd80ad2b$export$192d6a5eae5d7b58), {
                agents: activeAgents,
                isOpen: isAgentGroupOverflowOpen,
                onMoreClick: ()=>handleAgentGroupOverflowMenuClick(activeAgents.length)
            }));
        $[13] = activeAgents;
        $[14] = formatMessage;
        $[15] = handleAgentGroupOverflowMenuClick;
        $[16] = isAgentGroupOverflowOpen;
        $[17] = isNestedInPresenceAvatarGroup;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== isAgentGroupOverflowOpen || $[20] !== renderAgentGroupOverflowMenu || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            placement: "bottom-end",
            isOpen: isAgentGroupOverflowOpen,
            onClose: handleAgentGroupOverflowMenuClose,
            content: renderAgentGroupOverflowMenu,
            trigger: t8
        });
        $[19] = isAgentGroupOverflowOpen;
        $[20] = renderAgentGroupOverflowMenu;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
const $4dfa4fcf3782a7bf$var$useAgentsByIds = (0, $lJ6db.createHookWithAssistanceService)(({ agentIds: agentIds, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { data: data } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agentPresenceAgentsByIds',
            ...agentIds.slice().sort()
        ],
        queryFn: async ()=>{
            const agentResults = await Promise.allSettled(agentIds.map((agentId)=>assistanceService.getAgentDetails(agentId)));
            return agentResults.flatMap((result)=>result.status === 'fulfilled' ? [
                    result.value
                ] : []);
        },
        enabled: agentIds.length > 0
    });
    return data ?? [];
});
const $4dfa4fcf3782a7bf$export$3c0017d495bde3b3 = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { activeAgentIds: activeAgentIds, activeAgentPresenceById: activeAgentPresenceById } = $4dfa4fcf3782a7bf$var$useActiveAgentPresence(presenceProvider);
    let t1;
    if ($[0] !== cloudId) {
        t1 = $4dfa4fcf3782a7bf$var$buildAssistanceServiceParams(cloudId);
        $[0] = cloudId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== activeAgentIds || $[3] !== t1) {
        t2 = {
            agentIds: activeAgentIds,
            assistanceServiceParams: t1
        };
        $[2] = activeAgentIds;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const agentsFromAssistanceService = $4dfa4fcf3782a7bf$var$useAgentsByIds(t2);
    const [agentsById, setAgentsById] = (0, $cozmU.useState)($4dfa4fcf3782a7bf$var$_temp5);
    let t3;
    let t4;
    if ($[5] !== activeAgentIds || $[6] !== agentsFromAssistanceService) {
        t3 = ()=>{
            setAgentsById((previousAgentsById)=>$4dfa4fcf3782a7bf$var$updateCachedAgentsById(previousAgentsById, activeAgentIds, agentsFromAssistanceService.map($4dfa4fcf3782a7bf$var$_temp6)));
        };
        t4 = [
            activeAgentIds,
            agentsFromAssistanceService
        ];
        $[5] = activeAgentIds;
        $[6] = agentsFromAssistanceService;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== activeAgentIds || $[10] !== activeAgentPresenceById || $[11] !== agentsById || $[12] !== agentsFromAssistanceService) {
        let t6;
        if ($[14] !== activeAgentPresenceById || $[15] !== agentsById || $[16] !== agentsFromAssistanceService) {
            t6 = (agentId)=>{
                const agent_1 = agentsFromAssistanceService.find((agent_0)=>agent_0.id === agentId) ?? agentsById.get(agentId);
                return agent_1 ? {
                    ...agent_1,
                    ...activeAgentPresenceById.get(agentId)
                } : agent_1;
            };
            $[14] = activeAgentPresenceById;
            $[15] = agentsById;
            $[16] = agentsFromAssistanceService;
            $[17] = t6;
        } else t6 = $[17];
        t5 = $4dfa4fcf3782a7bf$var$getUniqueAgents(activeAgentIds.map(t6));
        $[9] = activeAgentIds;
        $[10] = activeAgentPresenceById;
        $[11] = agentsById;
        $[12] = agentsFromAssistanceService;
        $[13] = t5;
    } else t5 = $[13];
    const activeAgents = t5;
    let t6;
    if ($[18] !== activeAgents || $[19] !== isNestedInPresenceAvatarGroup || $[20] !== onActiveAgentsChange) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$AgentPresenceView, {
            activeAgents: activeAgents,
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange
        });
        $[18] = activeAgents;
        $[19] = isNestedInPresenceAvatarGroup;
        $[20] = onActiveAgentsChange;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
};
const $4dfa4fcf3782a7bf$var$createFallbackAgent = (agentId, name)=>({
        id: agentId,
        identity_account_id: null,
        named_id: agentId,
        name: name,
        description: null,
        creator_type: 'CUSTOMER',
        available_plugins: {},
        is_default: false,
        actor_type: 'AGENT',
        user_defined_conversation_starters: null,
        favourite: false,
        deactivated: false,
        isExternalAgentFallback: true
    });
const $4dfa4fcf3782a7bf$var$useAgentsByIdsWithAgentEdits = (0, $lJ6db.createHookWithAssistanceService)(({ agentIds: agentIds, fallbackAgentName: fallbackAgentName, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const { data: data } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agentPresenceAgentsByIds',
            ...agentIds.slice().sort()
        ],
        queryFn: async ()=>{
            const entries = await Promise.all(agentIds.map(async (agentId)=>{
                try {
                    return [
                        agentId,
                        await assistanceService.getAgentDetails(agentId)
                    ];
                } catch  {
                    try {
                        return [
                            agentId,
                            await assistanceService.getAgentDetailsByIdentityAccountId(agentId)
                        ];
                    } catch  {
                        return [
                            agentId,
                            $4dfa4fcf3782a7bf$var$createFallbackAgent(agentId, fallbackAgentName)
                        ];
                    }
                }
            }));
            return new Map(entries);
        },
        enabled: agentIds.length > 0
    });
    return data ?? null;
});
const $4dfa4fcf3782a7bf$var$AgentPresenceComponentWithAgentEdits = (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { activeAgentIds: activeAgentIds, activeAgentPresenceById: activeAgentPresenceById } = $4dfa4fcf3782a7bf$var$useActiveAgentPresence(presenceProvider);
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($4dfa4fcf3782a7bf$var$i18n.externalAgentName);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== cloudId) {
        t2 = $4dfa4fcf3782a7bf$var$buildAssistanceServiceParams(cloudId);
        $[2] = cloudId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== activeAgentIds || $[5] !== t1 || $[6] !== t2) {
        t3 = {
            agentIds: activeAgentIds,
            fallbackAgentName: t1,
            assistanceServiceParams: t2
        };
        $[4] = activeAgentIds;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const resolvedAgentsById = $4dfa4fcf3782a7bf$var$useAgentsByIdsWithAgentEdits(t3);
    const [agentsById, setAgentsById] = (0, $cozmU.useState)($4dfa4fcf3782a7bf$var$_temp7);
    let t4;
    let t5;
    if ($[8] !== activeAgentIds || $[9] !== resolvedAgentsById) {
        t4 = ()=>{
            setAgentsById((previous)=>$4dfa4fcf3782a7bf$var$updateCachedAgentsById(previous, activeAgentIds, resolvedAgentsById ?? []));
        };
        t5 = [
            activeAgentIds,
            resolvedAgentsById
        ];
        $[8] = activeAgentIds;
        $[9] = resolvedAgentsById;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[12] !== activeAgentIds || $[13] !== activeAgentPresenceById || $[14] !== agentsById || $[15] !== resolvedAgentsById) {
        let t7;
        if ($[17] !== activeAgentPresenceById || $[18] !== agentsById || $[19] !== resolvedAgentsById) {
            t7 = (agentId)=>{
                const agent = resolvedAgentsById?.get(agentId) ?? agentsById.get(agentId);
                return agent ? {
                    ...agent,
                    ...activeAgentPresenceById.get(agentId)
                } : agent;
            };
            $[17] = activeAgentPresenceById;
            $[18] = agentsById;
            $[19] = resolvedAgentsById;
            $[20] = t7;
        } else t7 = $[20];
        t6 = $4dfa4fcf3782a7bf$var$getUniqueAgents(activeAgentIds.map(t7));
        $[12] = activeAgentIds;
        $[13] = activeAgentPresenceById;
        $[14] = agentsById;
        $[15] = resolvedAgentsById;
        $[16] = t6;
    } else t6 = $[16];
    const activeAgents = t6;
    let t7;
    if ($[21] !== activeAgents || $[22] !== isNestedInPresenceAvatarGroup || $[23] !== onActiveAgentsChange) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$AgentPresenceView, {
            activeAgents: activeAgents,
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange
        });
        $[21] = activeAgents;
        $[22] = isNestedInPresenceAvatarGroup;
        $[23] = onActiveAgentsChange;
        $[24] = t7;
    } else t7 = $[24];
    return t7;
};
const $4dfa4fcf3782a7bf$export$b5ab3015117320e0 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup, onActiveAgentsChange: onActiveAgentsChange, presenceProvider: presenceProvider } = t0;
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    if (!isAdminHubAIEnabled || !isAIEarlyAccessEnabled || !(0, $6mKj3.expValEquals)("reinstate_confluence_agent_presence", "isEnabled", true) || isNestedInPresenceAvatarGroup && !(0, $9wGTI.fg)("platform_move_presence_agents")) return null;
    let t1;
    if ($[0] !== isNestedInPresenceAvatarGroup || $[1] !== onActiveAgentsChange || $[2] !== presenceProvider) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE
        }, (0, $6mKj3.expValEquals)("platform_editor_agent_be_streaming", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$var$AgentPresenceComponentWithAgentEdits, {
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange,
            presenceProvider: presenceProvider
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfa4fcf3782a7bf$export$3c0017d495bde3b3, {
            isNestedInPresenceAvatarGroup: isNestedInPresenceAvatarGroup,
            onActiveAgentsChange: onActiveAgentsChange,
            presenceProvider: presenceProvider
        }));
        $[0] = isNestedInPresenceAvatarGroup;
        $[1] = onActiveAgentsChange;
        $[2] = presenceProvider;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
function $4dfa4fcf3782a7bf$var$_temp() {
    return new Map();
}
function $4dfa4fcf3782a7bf$var$_temp2(agent) {
    return agent.permit?.isPermittedToView || agent.permit?.isPermittedToEdit;
}
function $4dfa4fcf3782a7bf$var$_temp3(agent_0) {
    return $4dfa4fcf3782a7bf$var$getAgentIdFromParticipantUserId(agent_0.userId);
}
function $4dfa4fcf3782a7bf$var$_temp4(isAgentGroupOverflowOpenState) {
    return !isAgentGroupOverflowOpenState;
}
function $4dfa4fcf3782a7bf$var$_temp5() {
    return new Map();
}
function $4dfa4fcf3782a7bf$var$_temp6(agent) {
    return [
        agent.id,
        agent
    ];
}
function $4dfa4fcf3782a7bf$var$_temp7() {
    return new Map();
}
module.exports["AgentPresenceComponent"] = $4dfa4fcf3782a7bf$export$3c0017d495bde3b3;
module.exports["AgentPresence"] = $4dfa4fcf3782a7bf$export$b5ab3015117320e0;

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            }
    }
});
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path.
        actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("caCU7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9d7Pd = parcelRequire("9d7Pd");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $iwQHw = parcelRequire("iwQHw");


var $c6zRP = parcelRequire("c6zRP");

const $6721937fde404080$var$i18n = (0, $kSwu1.defineMessages)({
    editing: {
        id: "team-presence.agent-group-menu.editing",
        defaultMessage: "Editing"
    },
    editingInactive: {
        id: "team-presence.agent-group-menu.editing-inactive",
        defaultMessage: "Editing (Inactive)"
    },
    editingWithActor: {
        id: "team-presence.agent-group-menu.editing-with-actor",
        defaultMessage: "with {actorName} \u2022 Editing"
    },
    editingWithActorInactive: {
        id: "team-presence.agent-group-menu.editing-with-actor-inactive",
        defaultMessage: "with {actorName} \u2022 Editing (Inactive)"
    },
    viewing: {
        id: "team-presence.agent-group-menu.viewing",
        defaultMessage: "Viewing"
    },
    viewingInactive: {
        id: "team-presence.agent-group-menu.viewing-inactive",
        defaultMessage: "Viewing (Inactive)"
    },
    viewingWithActor: {
        id: "team-presence.agent-group-menu.viewing-with-actor",
        defaultMessage: "with {actorName} \u2022 Viewing"
    },
    viewingWithActorInactive: {
        id: "team-presence.agent-group-menu.viewing-with-actor-inactive",
        defaultMessage: "with {actorName} \u2022 Viewing (Inactive)"
    }
});
const $6721937fde404080$export$e32187f91d1fd188 = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { actingUserName: actingUserName, agent: agent } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (agentId)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "aiAgentPresenceGroupOverflowMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "aiAgentPresenceGroupOverflowMenuItem",
                    product: "confluence",
                    attributes: {
                        agentId: agentId
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const handleAgentClick = t1;
    let t2;
    if ($[2] !== actingUserName || $[3] !== agent) {
        t2 = ()=>{
            if (!(0, $9wGTI.fg)("platform_move_presence_agents")) return;
            const isInactive = (0, $c6zRP.isAgentPresenceInactive)(agent);
            if (agent.presenceActivity === "editor") return actingUserName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...isInactive ? $6721937fde404080$var$i18n.editingWithActorInactive : $6721937fde404080$var$i18n.editingWithActor,
                values: {
                    actorName: actingUserName
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isInactive ? $6721937fde404080$var$i18n.editingInactive : $6721937fde404080$var$i18n.editing);
            return actingUserName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...isInactive ? $6721937fde404080$var$i18n.viewingWithActorInactive : $6721937fde404080$var$i18n.viewingWithActor,
                values: {
                    actorName: actingUserName
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isInactive ? $6721937fde404080$var$i18n.viewingInactive : $6721937fde404080$var$i18n.viewing);
        };
        $[2] = actingUserName;
        $[3] = agent;
        $[4] = t2;
    } else t2 = $[4];
    const getPresenceDescription = t2;
    let t3;
    if ($[5] !== agent.id || $[6] !== handleAgentClick) {
        t3 = ()=>handleAgentClick(agent.id);
        $[5] = agent.id;
        $[6] = handleAgentClick;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== agent) {
        t4 = (0, $9wGTI.fg)("platform_move_presence_agents") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent,
            presenceColorKey: agent.presenceId,
            size: "small",
            showBorder: true,
            showPresenceBadge: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iwQHw.AgentPresenceAvatar), {
            agent: agent
        });
        $[8] = agent;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== getPresenceDescription) {
        t5 = getPresenceDescription();
        $[10] = getPresenceDescription;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== agent.name || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            onClick: t3,
            iconBefore: t4,
            description: t5
        }, agent.name);
        $[12] = agent.name;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};
module.exports["AgentPresenceMenuItem"] = $6721937fde404080$export$e32187f91d1fd188;

});

parcelRegister("iwQHw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $iMnC5 = parcelRequire("iMnC5");


var $6gGPb = parcelRequire("6gGPb");


var $ji12t = parcelRequire("ji12t");


var $9wGTI = parcelRequire("9wGTI");


var $9VtwR = parcelRequire("9VtwR");

const $82c5dbca758f5691$var$AGENT_AVATAR_CLIP_PATH = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $82c5dbca758f5691$var$AGENT_AVATAR_BORDER_WIDTH = 2;
const $82c5dbca758f5691$var$AGENT_AVATAR_SIZE_PX = {
    small: 24,
    medium: 32
};
const $82c5dbca758f5691$var$externalAgentAvatarBackgroundStyles = null;
const $82c5dbca758f5691$var$styles = {
    root: "_3iDTPbccYA _3YEZNOdnbC _1mT5xdRAKS",
    overlapped: "_0GTcwRTUhv",
    border: "_3iDTPbQ4SZ _3YEZNOdnbC _0hPCNLDIqT _37wbyuDIqT _1uo2ZfTcEg",
    badge: "_0bjKvDKxmn _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VxpxF _39xV02xpxF _1kk5Tk7GSX",
    legacyBorder: "_1mT5xdRAKS _1llTr68BLF"
};
const $82c5dbca758f5691$var$ExternalAgentAvatar = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { size: size } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbccYA _1uo2ZfTcEg _2yBoao1qiM"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== size) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "external-agent-avatar",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: size
        }));
        $[1] = size;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
function $82c5dbca758f5691$export$1233303c82069087(t0) {
    const $ = (0, $bDgLe.c)(41);
    const { agent: agent, presenceColorKey: presenceColorKey, isOverlapped: isOverlapped, stackIndex: stackIndex, showPresenceBadge: showPresenceBadge, showBorder: showBorder, size: t1 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    let t2;
    if ($[0] !== agent) {
        t2 = (avatarSize)=>agent.isExternalAgentFallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82c5dbca758f5691$var$ExternalAgentAvatar, {
                size: avatarSize
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                key: agent.id,
                agentId: agent.id,
                agentIdentityAccountId: agent.identity_account_id,
                agentNamedId: agent.external_config_reference ?? agent.named_id,
                size: avatarSize,
                showBorder: false,
                isForgeAgent: (0, $ji12t.isForgeAgent)(agent),
                forgeAgentIconUrl: agent.icon
            });
        $[0] = agent;
        $[1] = t2;
    } else t2 = $[1];
    const renderAgentAvatar = t2;
    if (!(0, $9wGTI.fg)("platform_move_presence_agents")) {
        const t3 = showBorder && $82c5dbca758f5691$var$styles.legacyBorder;
        let t4;
        if ($[2] !== t3) {
            t4 = (0, $w6R6I.cx)(t3);
            $[2] = t3;
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== stackIndex) {
            t5 = {
                zIndex: stackIndex
            };
            $[4] = stackIndex;
            $[5] = t5;
        } else t5 = $[5];
        let t6;
        if ($[6] !== renderAgentAvatar) {
            t6 = renderAgentAvatar("medium");
            $[6] = renderAgentAvatar;
            $[7] = t6;
        } else t6 = $[7];
        let t7;
        if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t4,
                style: t5
            }, t6);
            $[8] = t4;
            $[9] = t5;
            $[10] = t6;
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    const t3 = presenceColorKey ?? agent.id;
    let t4;
    if ($[12] !== t3) {
        t4 = (0, $9VtwR.getParticipantColors)(t3);
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    const colors = t4;
    let t5;
    if ($[14] !== colors || $[15] !== showPresenceBadge) {
        t5 = showPresenceBadge ? {
            "--agent-presence-border-color": colors.backgroundColor,
            "--agent-presence-badge-background": colors.backgroundColor,
            "--agent-presence-badge-color": colors.textColor
        } : undefined;
        $[14] = colors;
        $[15] = showPresenceBadge;
        $[16] = t5;
    } else t5 = $[16];
    const presenceColorStyles = t5;
    let t6;
    if ($[17] !== presenceColorStyles || $[18] !== stackIndex) {
        t6 = {
            zIndex: stackIndex,
            ...presenceColorStyles
        };
        $[17] = presenceColorStyles;
        $[18] = stackIndex;
        $[19] = t6;
    } else t6 = $[19];
    const rootStyle = t6;
    const borderedAvatarSize = $82c5dbca758f5691$var$AGENT_AVATAR_SIZE_PX[size] + $82c5dbca758f5691$var$AGENT_AVATAR_BORDER_WIDTH * 2;
    const shouldShowPresenceBadge = showPresenceBadge && agent.presenceActivity === "editor";
    let t7;
    if ($[20] !== borderedAvatarSize) {
        t7 = {
            backgroundColor: "var(--agent-presence-border-color, var(--ds-icon-inverse, #FFFFFF))",
            height: borderedAvatarSize,
            width: borderedAvatarSize
        };
        $[20] = borderedAvatarSize;
        $[21] = t7;
    } else t7 = $[21];
    const borderStyle = t7;
    let t8;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            backgroundColor: "var(--agent-presence-badge-background)",
            bottom: "-2px",
            color: "var(--agent-presence-badge-color)",
            fontSize: 10,
            right: "-2px",
            userSelect: "none",
            zIndex: 2
        };
        $[22] = t8;
    } else t8 = $[22];
    const badgeStyle = t8;
    let t9;
    if ($[23] !== renderAgentAvatar || $[24] !== size) {
        t9 = renderAgentAvatar(size);
        $[23] = renderAgentAvatar;
        $[24] = size;
        $[25] = t9;
    } else t9 = $[25];
    const agentAvatar = t9;
    const t10 = showBorder && $82c5dbca758f5691$var$styles.root;
    const t11 = isOverlapped && $82c5dbca758f5691$var$styles.overlapped;
    let t12;
    if ($[26] !== t10 || $[27] !== t11) {
        t12 = (0, $w6R6I.cx)(t10, t11);
        $[26] = t10;
        $[27] = t11;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== agentAvatar || $[30] !== borderStyle || $[31] !== showBorder) {
        t13 = showBorder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $82c5dbca758f5691$var$styles.border,
            style: borderStyle
        }, agentAvatar) : agentAvatar;
        $[29] = agentAvatar;
        $[30] = borderStyle;
        $[31] = showBorder;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== agent.name || $[34] !== shouldShowPresenceBadge) {
        t14 = shouldShowPresenceBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $82c5dbca758f5691$var$styles.badge,
            style: badgeStyle,
            testId: "agent-presence-avatar-badge"
        }, agent.name?.substring(0, 1));
        $[33] = agent.name;
        $[34] = shouldShowPresenceBadge;
        $[35] = t14;
    } else t14 = $[35];
    let t15;
    if ($[36] !== rootStyle || $[37] !== t12 || $[38] !== t13 || $[39] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t12,
            style: rootStyle,
            testId: "agent-presence-avatar"
        }, t13, t14);
        $[36] = rootStyle;
        $[37] = t12;
        $[38] = t13;
        $[39] = t14;
        $[40] = t15;
    } else t15 = $[40];
    return t15;
}
module.exports["AgentPresenceAvatar"] = $82c5dbca758f5691$export$1233303c82069087;

});

parcelRegister("c6zRP", function(module, exports) {
const $49bfa46c557a50ec$export$64cd126c152ef69d = 30000;
const $49bfa46c557a50ec$export$f1e7f4004cc0d32 = 300000;
const $49bfa46c557a50ec$var$hasValidLastActive = (lastActive)=>typeof lastActive === 'number' && Number.isFinite(lastActive);
const $49bfa46c557a50ec$export$545448b69b42d8b = (agent, now = Date.now())=>{
    if (!$49bfa46c557a50ec$var$hasValidLastActive(agent.lastActive)) return 'active';
    const age = now - agent.lastActive;
    if (age >= $49bfa46c557a50ec$export$f1e7f4004cc0d32) return 'expired';
    if (age >= $49bfa46c557a50ec$export$64cd126c152ef69d) return 'inactive';
    return 'active';
};
const $49bfa46c557a50ec$export$70aa8e977829b349 = (lastActive, now = Date.now())=>{
    if (!$49bfa46c557a50ec$var$hasValidLastActive(lastActive)) return undefined;
    const inactiveAt = lastActive + $49bfa46c557a50ec$export$64cd126c152ef69d;
    if (inactiveAt > now) return inactiveAt;
    const expiresAt = lastActive + $49bfa46c557a50ec$export$f1e7f4004cc0d32;
    return expiresAt > now ? expiresAt : undefined;
};
const $49bfa46c557a50ec$export$f262baf6c8c08ca8 = (agent)=>$49bfa46c557a50ec$export$545448b69b42d8b(agent) !== 'active';
module.exports["getAgentPresenceStatus"] = $49bfa46c557a50ec$export$545448b69b42d8b;
module.exports["getNextAgentPresenceBoundary"] = $49bfa46c557a50ec$export$70aa8e977829b349;
module.exports["isAgentPresenceInactive"] = $49bfa46c557a50ec$export$f262baf6c8c08ca8;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("fmu9K", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("iTJtk")).FabricChannel);

var $hpWmZ = parcelRequire("hpWmZ");


var $lMjmr = parcelRequire("lMjmr");


var $iTJtk = parcelRequire("iTJtk");


});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("6e6qw", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");

function $c454c81005f3f72e$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $c454c81005f3f72e$export$60ba61eca4eb64f2(str) {
    const index = $c454c81005f3f72e$export$c14f61804029af13(str) % (0, $7Y8M5.participantColors).length;
    return {
        index: index,
        color: (0, $7Y8M5.participantColors)[index]
    };
}
module.exports["getHashCode"] = $c454c81005f3f72e$export$c14f61804029af13;
module.exports["getParticipantColor"] = $c454c81005f3f72e$export$60ba61eca4eb64f2;

});


//# sourceMappingURL=AgentPresence.4c9d3389.js.map
